import React from "react";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import SearchBar from "../library/SearchBar";
import SortControl from "./SortControl";
import ViewToggle from "./ViewToggle";

const CreativeToolbar = ({
  searchText,
  onSearch,
  sortOption,
  sortDirection,
  onSortChange,
  onDirectionChange,
  viewMode,
  onViewModeChange,
  onUpload,
  showUpload,
  hideSort,
  hideViewToggle,
}) => {
  return (
    <div className="creative-library__toolbar">
      <div className="creative-library__toolbar-left">
        <SearchBar onSearch={onSearch} searchText={searchText} />
        {!hideSort && (
          <SortControl
            sortOption={sortOption}
            sortDirection={sortDirection}
            onSortChange={onSortChange}
            onDirectionChange={onDirectionChange}
          />
        )}
      </div>
      <div className="creative-library__toolbar-right">
        {!hideViewToggle && (
          <ViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
        )}
        {showUpload && (
          <Button
            className="creative-library__upload-btn"
            type="primary"
            icon={<UploadOutlined />}
            onClick={onUpload}
          >
            Upload
          </Button>
        )}
      </div>
    </div>
  );
};

export default CreativeToolbar;
